module.exports = __webpack_public_path__ + "img/fuwenben1.1f62b2cc.png";